import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class ListBeneficiari extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            strSearchString:'',
            elementeAfisate:[]
            
        } 
    }



    componentDidMount(){
       this.setState({ elementeAfisate:this.props.elemente || []})
    }


    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        if(tx !== null){

            return tx.substring(0,1).toUpperCase()
        }
    }

    filterFunc = (ev) => {

        this.setState({strSearchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.nume]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            return false

        })

        this.setState({elementeAfisate: e})
    }

    render(){
        return (
            <div className='pm-users-list-container'>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{cursor:'pointer', position:'relative'}} className='pm-list-container'>
                <li className='pm-list-item-user' >
                                   
                                   <Grid container className='pm-list-container-avatar-head' >
                                   
   
                                       <Grid item xs={7} sm={7} md={7} lg={7} xl={7} style={{justifyContent:'left'}}  className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>Beneficiar</span>
                                       </Grid>
                                       <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{justifyContent:'left'}}   className='pm-list-item-avatar-head'>
                                           <span className='pm-list-item-span-head'>Administrator</span>
                                       </Grid>

                                      
                       
                                       
                                      
                                   </Grid>
                                      
                                   </li>
                  
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item-user' key={idx}  >
                                   
                                <Grid container   className='pm-list-container-avatar'>
                                
                                

                                    <Grid    item xs={7} sm={7} md={7} lg={7} xl={7}  className='pm-list-item-avatar'>
                                    <input style={{backgroundColor:'transparent', width:'80%', textAlign:'center'}}  className='pm-task-time-input' type='text' value={e[this.props.onlyColumns.nume_beneficiar]}  onChange={(ev)=>{this.props.beneficiarChange(e,ev)}} onBlur={()=>{this.props.updateBeneficiar(e)}} /> 
                                

                                    </Grid>

                                    <Grid  item xs={3} sm={3} md={3} lg={3} xl={3}  className='pm-list-item-avatar'>
                                    
                                    <input style={{display:e.id_beneficiar !== null ? 'block' : 'none', backgroundColor:'transparent',width:'80%',textAlign:'center'}}  className='pm-task-time-input' type='text' value={e[this.props.onlyColumns.nume_administrator] || ''}  onChange={(ev)=>{this.props.administratorChange(e,ev)}} onBlur={()=>{this.props.updateAdministrator(e)}} /> 
                                
                                        <i onClick={()=>{this.props.openEditAdmin(e)}} 
                                                style={{margin:'auto', color:'#3fde3f', display:e.id_administrator !== null ? 'block' : 'none'}} className='material-icons'>edit</i>
                                    </Grid>
                                  
                    
                                    
                                   
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


ListBeneficiari.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    beneficiarChange:PropTypes.func,
    administratorChange:PropTypes.func,
    updateBeneficiar:PropTypes.func,
    updateAdministrator:PropTypes.func,
    openEditAdmin:PropTypes.func,

}